module.exports = __webpack_public_path__ + "img/welcome_16.8d5a1646.jpg";